/**
 * 受注一覧
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/assigns`

 const allocate_entry_assign = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit }, { target_date, keyword, with_assigned }) {
      const params = { target_date: target_date, keyword: keyword, with_assigned: with_assigned }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          // let content = data.content
          // commit(types.DRIVER_DISPOSER, { content })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_assign
